import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useIsDesktop, useTestId } from "@/hooks";
import { useRefsContext } from "@/contexts/ref";
import { Facts, MortgagePriceLink } from "@/components/Sections/Hardfacts";
import { CTAs } from "@/components/CTAs";
import { Divider } from "@gemini/ui";
import { HardfactInfo } from "@/components/Sections/Hardfacts/HardfactInfo";
import { RentalLink } from "@/ads/components/RentalLink";
import { ProjectHardfactInfo } from "@/components/Sections/Hardfacts/HardfactInfo/ProjectHardfactInfo";
import { useIsNewBuildProject } from "@/shared/hooks";
export const Hardfacts = () => {
    const testId = useTestId("Sections.Hardfacts");
    const { hardfactsRef } = useRefsContext();
    const isDesktop = useIsDesktop();
    const isProject = useIsNewBuildProject();
    return (_jsxs(Box, { ref: hardfactsRef, testId: testId, position: "relative", children: [_jsxs(Box, { display: "flex", gap: "spacing.12", children: [isProject ? _jsx(ProjectHardfactInfo, {}) : _jsx(HardfactInfo, {}), _jsx(CTAs, { showPrint: true, showBorder: isDesktop })] }), _jsx(MortgagePriceLink, {}), _jsx(RentalLink, {}), _jsx(Divider, { "aria-hidden": "true", marginVertical: "spacing.16" }), _jsx(Facts, {})] }));
};
